import answer from "./mail/answer.js";

export default {
	answer
};



// WEBPACK FOOTER //
// ./src/i18n/de/home/steps/1/type/visit/invitation/yes/documents/mail.js